// Карточка «Выберите команды» на первом экране (HQ-726): над блоками главной и наверху «Матчей» — вкладки home в живом
// tab_bar нет, первый экран — matches (default_key), карточка стоит там, где её видит человек. Решает правило pickTeamsModel.shouldShowCard: сессия,
// набор с сервера пуст, «Пропустить» не нажимали последние 7 дней. Первая же звезда (здесь или где угодно) — набор
// не пуст, карточка уходит сама.
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../../i18n/i18n';
import { favoritesCount, useFavoritesState } from '../../session/favorites';
import { haptic } from '../../telegram/webapp';
import { onboardingMark } from '../onboarding/onboardingModel';
import { PICK_TEAMS_ROUTE, shouldShowCard, skipActive, skipCard, trackCardResult, trackCardView } from './pickTeamsModel';
import styles from './PickTeams.module.css';

/** inset — свои поля вокруг карточки: на «Матчах» у экрана нет общих полей, как у главной (.page). */
export function PickTeamsCard({ inset = false }: { inset?: boolean }) {
  const { set, loaded, session } = useFavoritesState();
  const [skipped, setSkipped] = useState(() => skipActive());
  const show = shouldShowCard({ session, loaded, count: favoritesCount(set), skipped, onboarded: onboardingMark() === 'done' });
  if (!show) return null;
  const card = <PickTeamsCardView onSkip={() => { skipCard(); setSkipped(true); }} />;
  return inset ? <div className={styles.inset}>{card}</div> : card;
}

export function PickTeamsCardView({ onSkip }: { onSkip: () => void }) {
  const navigate = useNavigate();
  useEffect(() => { trackCardView(); }, []);
  return (
    <section className={styles.card} aria-label={t('tg_pick_teams_title')}>
      <div className={styles.cardTitle}>{t('tg_pick_teams_title')}</div>
      <div className={styles.cardText}>{t('mc_onb_policy_p2_body')}</div>
      <div className={styles.cardActions}>
        <button className={styles.primary} onClick={() => { haptic.impact('light'); trackCardResult('continue'); navigate(PICK_TEAMS_ROUTE); }}>
          {t('tg_pick_teams_choose')}
        </button>
        <button className={styles.secondary} onClick={onSkip}>{t('mc_onb_skip')}</button>
      </div>
    </section>
  );
}
